module.exports = __webpack_public_path__ + "static/img/3.0ecac93.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slide/3.jpg
// module id = 22s+
// module chunks = 1